import { faCheck, faDownload, faExclamationCircle, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext } from 'react'
import { openDocument } from '../../../../../../libs/files/openDocument'
import DocumentsContext from './DocumentsProvider'

export default function DocumentLineItem({ item, hideRemove }) {
    const { remove, getFile } = useContext(DocumentsContext)

    const setPreviewMessage = (previewWindow, title, message) => {
        if (!previewWindow || previewWindow.closed) return

        try {
            previewWindow.document.title = title
            previewWindow.document.body.innerHTML = `<div style="font-family: sans-serif; padding: 1rem;">${message}</div>`
        } catch (e) { }
    }

    async function openDocumentLineItem(fileId) {
        const previewWindow = window.open('about:blank', 'drdata-document-preview')
        setPreviewMessage(previewWindow, 'Opening document...', 'Loading document...')

        try {
            const response = await getFile(fileId)

            if (!response || !response.data) {
                setPreviewMessage(previewWindow, 'Document unavailable', 'The document could not be loaded.')
                return
            }

            try {
                openDocument(response.data, response.mimeType, response.fileName, previewWindow)
            } catch (previewError) {
                // Fallback to a normal open path if reusing the preview tab fails.
                openDocument(response.data, response.mimeType, response.fileName)
            }
        } catch (e) {
            const details = e && e.message ? `An error occurred while opening the document. ${e.message}` : 'An error occurred while opening the document.'
            setPreviewMessage(previewWindow, 'Error opening document', details)
            console.error(e)
        }
    }
    const _status = (status) => {
        switch (status) {
            case 'Uploading': return <FontAwesomeIcon icon={faSpinner} spin />
            case 'Uploaded': return <FontAwesomeIcon icon={faCheck} />
            case 'Failed': return <FontAwesomeIcon icon={faExclamationCircle} />
            default: return <></>
        }
    }
    return (item ? <div className='d-flex bg-secondary-container justify-content-between m-1 rounded p-2 shadow'>
        <div className='flex-grow-1 text-start'>
            <div>{item.fileName}</div>
        </div>
        <div className='d-flex'>
            <div className='me-2'>{_status(item.status)}</div>
            {
                !item.status &&
                <>
                    {!hideRemove && <div onClick={() => remove(item.id)} className='me-2'><FontAwesomeIcon icon={faTrash} /></div>}
                    <div onClick={() => openDocumentLineItem(item.id)} className='me-2'><FontAwesomeIcon icon={faDownload} /></div>
                </>
            }
        </div>
    </div>
        :
        <div>Processing</div>
    )
}
